<template>
    <div class="popup crud-popup">
        <div class="popup-inner">
            <div class="popup-header">
                <h1>{{ $t(action) }}</h1>
                <img @click="close()" src="../../../../images/close.png" alt>
            </div>
            <div class="popup-body scroll-grey">
                <div class="crud-form">
                    <div :class="`form-field ${$HasError(errors, 'name') ? 'field-invalid' : ''}`">
                        <div class="field-label">{{ $t('name') }} </div>
                        <el-input size="medium" v-model="model.name"></el-input>
                        <div v-if="$HasError(errors, 'name')" class="field-error">
                            <span>{{ $GetError(errors, 'name') }}</span>
                        </div>
                    </div>
                    <div :class="`form-field ${$HasError(errors, 'parent_id') ? 'field-invalid' : ''}`">
                        <div class="field-label">{{ $t('parent') }} </div>
                        <el-select
                                v-model="model.parent_id"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="">
                            <el-option :value="null"></el-option>
                            <el-option
                                    v-for="category in categories"
                                    :key="'category-' + category.id"
                                    :label="category.path"
                                    :value="category.id">
                            </el-option>
                        </el-select>
                        <div v-if="$HasError(errors, 'parent_id')" class="field-error">
                            <span>{{ $GetError(errors, 'parent_id') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <el-button @click="close()" size="medium" type="danger" round>{{ $t('close') }}</el-button>
                <el-button @click="submit()" size="medium" type="success" round>{{ $t(action) }}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import helper from "../../../../mixins/helper";
    import {$http} from "../../../../hooks/api";
    import {base_url} from "../../../../constants/api";
    import {Message} from "element-ui";

    export default {
        mixins: [helper],
        data() {
            return {
                model: this.$parent.crud.model,
                errors: {}
            }
        },
        methods: {
            close(){
                this.$parent.toggleCrud(this.action);
            },
            submit(){
                if (this.action === 'create'){
                    this.create(this.model);
                } else{
                    this.update(this.model, this.model.id);
                }
            },
            create(model){
                this.$store.commit('setPreloader', true);
                $http().post(base_url + '/api/client/category', model).then(({data}) => {
                    if (data.success){
                        this.errors = {};

                        this.$parent.getCategories();

                        this.close();

                        Message({
                            message: data.message,
                            showClose: true,
                            type: 'success'
                        });
                    } else{
                        this.errors = data.errors;
                    }
                    this.$store.commit('setPreloader', false);
                }).catch(() => {
                    this.$store.commit('setPreloader', false);
                });
            },
            update(model, id){
                this.$store.commit('setPreloader', true);
                $http().put(base_url + '/api/client/category/' + id, model).then(({data}) => {
                    if (data.success){
                        this.errors = {};

                        this.$parent.getCategories();

                        this.close();

                        Message({
                            message: data.message,
                            showClose: true,
                            type: 'success'
                        });
                    } else{
                        this.errors = data.errors;
                    }
                    this.$store.commit('setPreloader', false);
                }).catch(() => {
                    this.$store.commit('setPreloader', false);
                });
            }
        },
        computed: {
            action: function () {
                return this.$parent.crud.action;
            },
            categories: function () {
                return this.$parent.categories.filter((category) => {
                    return category.id !== this.model.id && category['parent_ids'].indexOf(this.model.id) === -1;
                });
            }
        }
    }
</script>